<p>
  panel-config-usuario works!
</p>
